import { render } from "./PicCarousel.vue?vue&type=template&id=6a27f1ad&scoped=true"
import script from "./PicCarousel.vue?vue&type=script&lang=js"
export * from "./PicCarousel.vue?vue&type=script&lang=js"

import "./PicCarousel.vue?vue&type=style&index=0&id=6a27f1ad&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\AirFryer\\AirFryer_Berater\\AirFryer_Kaufberatung\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a27f1ad"]])

export default __exports__